module.exports = __webpack_public_path__ + "static/media/3_Foiled_02.bf76263b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/3_Foiled_02.jpg
// module id = 1707
// module chunks = 0